import { Component, input, OnInit, signal, ViewChild } from '@angular/core';
import { Wk8AudioButtonComponent } from '@features/wk8/core/wk8-audio-button/wk8-audio-button.component';
import { LpWoordData } from '@typings/lp/generated';

@Component({
  selector: 'wk8-panel-image',
  imports: [Wk8AudioButtonComponent],
  templateUrl: './wk8-panel-image.component.html',
  styleUrl: './wk8-panel-image.component.css',
})
export class Wk8PanelImageComponent implements OnInit {
  word = input.required<LpWoordData>();

  audio = signal<string | undefined>(undefined);

  @ViewChild('audioButton') audioButton?: Wk8AudioButtonComponent;

  ngOnInit() {
    this.audio.set(this.getRandomPronunciation());
  }

  getRandomPronunciation(): string | undefined {
    const audios = [this.word().pronunciation1, this.word().pronunciation2].filter((audio) => audio !== undefined);
    if (audios.length === 0) return undefined;

    return audios[Math.floor(Math.random() * audios.length)].url;
  }
}
